<template>
  <div class="w-full text-center">
    <div class="content">
      <div style="margin-bottom: 140px" class="flex flex-wrap mb-4">
        <div class="w-full" style="max-width: 500px; margin: 0 auto;">
          <h1 class="mb-6 text-center big-title">
            Complimenti! Hai completato la procedura di approvazione!
          </h1>

          <p class="text-center">
            Procederemo alla spedizione della carta prepagata.
          </p>

          <img
            class="reg-completed-img"
            src="../../assets/images/conto_ok.png"
          />

          <div class="info-box">
            <p class="f-b">Ricorda:</p>
            <ul class="text-grey">
              <li>
                La carta Tinaba sarà recapitata all'indirizzo inserito in app.
              </li>
              <li>
                È ricaricabile dal conto, dai gruppi Tinaba e dai progetti
                privati. Può inoltre essere associata a Samsung Pay, Apple Pay,
                Google Pay, Garmin Pay, Fitbit Pay e SwatchPay!.
              </li>
              <li>
                È utilizzabile per pagamenti nei punti vendita fisici e online e
                per prelevare contanti presso gli sportelli atm.
              </li>
              <li>
                Potrai controllare i limiti di ricarica e le operazioni del
                minore collegato direttamente dalla tua App, cliccando
                sull'icona con la tua immagine del profilo e selezionando
                "gestione minori".
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="page-footer">
      <button class="btn" @click="backToInitialView">
        Torna alla schermata iniziale
      </button>
    </div>
  </div>
</template>

<script>
import UtilityService from "@/services/UtilityService";

export default {
  name: "RegistrationCompleted",

  data() {
    return {};
  },
  mounted() {},
  methods: {
    backToInitialView() {
      UtilityService.backToInitialView();
    }
  }
};
</script>
<style lang="less" scoped>
.reg-completed-img {
  width: 150px;
  margin: 20px auto;
}
.info-box {
  text-align: left;
  p {
    margin-bottom: 22px;
  }
  ul {
    margin-left: 20px;
    list-style: initial;
  }
}
.info-card-box {
  margin-top: 160px;
  @media (max-width: 768px) {
    margin-top: 100px;
  }
  display: flex;
  height: 100%;
  align-items: center;
  text-align: left;
  .card {
    position: relative;
    .card__box {
      width: 300px;
    }
  }
  img {
    width: 200px;
    position: absolute;
    top: -90px;
    left: 100px;
  }
}
</style>
